import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Paper, Box, Grid } from '@mui/material';
import InfoCard from './InfoCard';
import { AuthContext } from 'core/context';
import { isLinkAccessable } from 'core/utils/common';
// import BookOnlineIcon from '@mui/icons-material/BookOnline';
// import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
// import PieChartIcon from '@mui/icons-material/PieChart';

import { getDashboardData } from 'services/dashboard';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {

  const [dashboardData, setDashboardData] = useState([]);
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { permissions = [] } = authContext?.data;


  const themeNames = [
    "yellow","red","orange","blue","purple","green",
  ];

  useEffect(() => {
    getDashboardDetails();
  }, []);

  function getDashboardDetails() {
    getDashboardData().then(({response, error}) => {
      if(response){
        setDashboardData([...response]);
      } else {
        setDashboardData({});
      }
    });
  }

  const onCardClick = useCallback((title) => {
    if(title === 'Total Vendors' && isLinkAccessable(['View vendor dashboard'], permissions)) {
      navigate('/dashboard/vendor/');
    }
  }, [navigate]);
  
  
  return (
    <Paper elevation={0} sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )", background: 'transparent' }}>
      {/* <Typography component="h2" variant="h6" color="primary" gutterBottom sx={{mb: 1}}>
        Dashboard
      </Typography>
      <Divider /> */}
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={5} rowSpacing={3} >
          {Array.isArray(dashboardData) ? dashboardData.map((data, i) => (
            <Grid item xs={12} sm={12} md={4} xl={3} lg={4} key={i}>
              <InfoCard title={data.title} theme={themeNames[i%6]} subTitle={data.subTitle} value={data.value} onclick={onCardClick} />
            </Grid>
          )): null}
        </Grid>
      </Box>
    </Paper>
  );
}
 
export default React.memo(Dashboard);
